// Lightweight slug arrays consumed by App.js for routing decisions only.
// The full data objects (LANDING_PAGES, SERVICES, HUBS) live in their own
// modules and are loaded only when the relevant lazy route component mounts —
// keeping the homepage initial bundle slim. Add new slugs here when adding
// a new entry to landingPages.js / content.js SERVICES / hubs.js.

export const LANDING_PAGE_SLUGS = [
  "sil-assessments",
  "sda-assessments",
  "telehealth-fca",
  "fca-for-autism",
  "psychosocial-fca",
  "neurological-fca",
  "intellectual-disability-fca",
  "physical-disability-fca",
  "home-and-living-assessments",
  "plan-review-reports",
  "letters-of-support",
  "support-coordinator-referrals",
];

export const HUB_SLUGS = [
  "what-is-a-functional-capacity-assessment",
  "ndis-funding-evidence",
  "fca-process",
  "case-studies",
  "conditions",
];
